import { Box, Typography, Divider } from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { useAppContext } from "../../context";
import WarningText from "../WarningText";

type CreateOrderType = {
    amount: number;
    sourceCurrency: string;
    result: number;
    targetCurrency: string;
};

export default function ConvertCard() {
    const {
        step,
        createOrder
    } = useAppContext();

    const typedCreateOrder = createOrder as CreateOrderType;


    return (
        <Box sx={{
            minHeight: "90%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            background: "#F1F5FA",
        }}>
            <Box
                sx={{
                    width: "90%",
                    mx: "auto",
                    background: "#F1F5FA",
                    p: { xs: 2, sm: 1.5, md: 2.5 },
                    borderRadius: "12px",
                }}
            >
                {/* HEADER */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 2,
                        flexDirection: { xs: "column", sm: "row" },
                        gap: { xs: 0.5, sm: 0 },
                    }}
                >
                    <Typography
                        className="font-helviteca"
                        sx={{ fontSize: { xs: "16px", sm: "18px" }, fontWeight: 600, color: "#1C3553" }}
                    >
                        კონვერტაცია
                    </Typography>

                    <Typography
                        className="font-helviteca"
                        sx={{ fontSize: { xs: "11px", sm: "12px" }, color: "#7A8FA6", textAlign: { xs: "right", sm: "left" } }}
                    >
                        ნაბიჯი {step}/3
                    </Typography>
                </Box>

                {/* PROGRESS BAR */}
                <Box sx={{ display: "flex", gap: 0.5, mb: 3 }}>
                    <Box sx={{ height: 4, flex: 1, borderRadius: 2, background: "#F95A4E" }} />
                    <Box sx={{ height: 4, flex: 1, borderRadius: 2, background: step >= 2 ? "#F95A4E" : "#D9E2ED" }} />
                    <Box sx={{ height: 4, flex: 1, borderRadius: 2, background: step === 3 ? "#F95A4E" : "#D9E2ED" }} />
                </Box>

                {/* SEND AMOUNT */}
                <Box sx={{ mb: 3 }}>
                    <Typography className="font-helviteca" sx={{ fontSize: "14px", color: "#7A8FA6" }}>
                        უნდა გადაცვალო
                    </Typography>

                    <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mt: 1 }}>
                        <Typography
                            className="font-helviteca"
                            sx={{ fontSize: { xs: "28px", sm: "34px" }, fontWeight: 700, color: "#1C3553" }}
                        >
                            {typedCreateOrder.amount}
                        </Typography>
                        <Typography className="font-helviteca" sx={{ fontSize: { xs: "18px", sm: "20px" }, color: "#1C3553" }}>
                            {typedCreateOrder.sourceCurrency}
                        </Typography>
                    </Box>

                    {/* <Typography className="font-helviteca" sx={{ fontSize: "13px", color: "#7A8FA6", mt: 0.5 }}>
                    {createOrder.sourceCurrency}
                </Typography> */}
                </Box>

                {/* SWAP + DIVIDER */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        mb: 3,
                        mt: -1,
                    }}
                >
                    <Divider sx={{ flex: 1 }} />
                    <SwapHorizIcon sx={{ fontSize: 20, color: "#7A8FA6" }} />
                    <Divider sx={{ flex: 1 }} />
                </Box>

                {/* RECEIVE AMOUNT */}
                <Box sx={{ mb: 1 }}>
                    <Typography className="font-helviteca" sx={{ fontSize: "14px", color: "#7A8FA6" }}>
                        გაქვს მისაღები
                    </Typography>

                    <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mt: 1 }}>
                        <Typography
                            className="font-helviteca"
                            sx={{ fontSize: { xs: "28px", sm: "34px" }, fontWeight: 700, color: "#1C3553" }}
                        >
                            {typedCreateOrder.result}
                        </Typography>
                        <Typography className="font-helviteca" sx={{ fontSize: { xs: "18px", sm: "20px" }, color: "#1C3553" }}>
                            {typedCreateOrder.targetCurrency}
                        </Typography>
                    </Box>

                    {/* <Typography className="font-helviteca" sx={{ fontSize: "13px", color: "#7A8FA6", mt: 0.5 }}>
                    {buyCurrencyInfo}
                </Typography> */}
                </Box>
            </Box>
            <Box
                sx={{
                    marginTop: "auto",   // 🔥 ეს არის მთავარი
                    width: { xs: "100%", sm: "90%" },
                    background: "#FFFFFF",
                    borderRadius: "12px",
                    p: { xs: 1.5, sm: 2 },
                    boxShadow: "0px -4px 12px rgba(0,0,0,0.08)",
                }}
            >
                <WarningText />
            </Box>
        </Box>

    );
}
